import { apiGet, apiPatch } from './client';
import type { Issuer, IssuerBatchRequest } from '../types/Issuer';

export function getIssuers(): Promise<Issuer[]> {
  return apiGet<Issuer[]>('/api/issuers');
}

export function saveIssuersBatch(
  added: Issuer[],
  modified: Issuer[],
  deletedIds: number[],
): Promise<Issuer[]> {
  return apiPatch<IssuerBatchRequest, Issuer[]>('/api/issuers/batch', {
    added,
    modified,
    deleted: deletedIds,
  });
}
